import { createFileRoute } from "@tanstack/react-router";
import { VendorBusinessRegistryPage } from "@/components/vendor/business-registry/VendorBusinessRegistryPage";

export const Route = createFileRoute("/vendor/registry-unternehmen")({
  head: () => ({ meta: [{ title: "Registry · Venue Portal" }] }),
  component: VendorBusinessRegistryPage,
});
